import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import "../css/content-page.scss";
import "../css/terms.scss";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function Terms() {
  return (
    <main className="content-page terms-page">
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath="/terms" />

        <article
          className="content-page__article"
          aria-labelledby="terms-title"
        >
          <header className="content-page__header">
            <p className="content-page__eyebrow">Storefront rules</p>
            <h1 id="terms-title">Terms &amp; Conditions</h1>
            <p className="content-page__lead">
              These terms describe use of the sickzuno storefront, orders and
              customer-service information.
            </p>
          </header>

          <p className="content-page__meta">Last updated: September 30, 2026</p>

          <div
            className="content-page__notice terms-page__template-note"
            role="note"
          >
            <strong>Please review:</strong> placing an order means you accept these
            terms together with the shipping, return and privacy policies.
          </div>

          <section
            className="content-page__callout"
            aria-labelledby="terms-demo-title"
          >
            <h2 id="terms-demo-title">Secure payment</h2>
            <p>
              Checkout collects contact and delivery details before directing
              customers to the site payment endpoint. Card details are not
              collected on the sickzuno checkout form.
            </p>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-use"
          >
            <h2 id="terms-use">1. Using this storefront</h2>
            <p>
              By using the site, you agree to interact with it lawfully and only
              for its intended shopping purposes. If you do not accept these
              terms, stop using the storefront.
            </p>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-products"
          >
            <h2 id="terms-products">2. Products, prices and availability</h2>
            <p>
              Names, descriptions, package choices, prices, ratings and
              availability are illustrative catalog data. They may be edited
              without notice and should not be treated as a current offer,
              nutritional statement or professional advice.
            </p>
            <p>
              Final product labels and allergen information would need to be
              verified before any food product is offered for sale.
            </p>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-cart"
          >
            <h2 id="terms-cart">3. Cart and checkout behavior</h2>
            <ul className="content-page__list">
              <li>
                Cart selections are stored in the visitor’s browser using local
                storage; adding an item does not reserve inventory.
              </li>
              <li>
                Checkout fields are held only in front-end component memory for
                the current page session.
              </li>
              <li>
                The Pay now action validates fields and directs the browser to
                the payment endpoint with the order details.
              </li>
              <li>
                Payment-card details must be entered only on the secure payment page.
              </li>
            </ul>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-conduct"
          >
            <h2 id="terms-conduct">4. Acceptable conduct</h2>
            <p>You may not use the site to:</p>
            <ul className="content-page__list">
              <li>
                interfere with its operation or attempt unauthorized access;
              </li>
              <li>
                upload harmful code or misuse forms to send abusive material;
              </li>
              <li>
                misrepresent sickzuno or a payment service; or
              </li>
              <li>
                copy or distribute protected brand assets without permission.
              </li>
            </ul>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-policies"
          >
            <h2 id="terms-policies">5. Shipping, returns and privacy</h2>
            <p>
              The shipping and return pages are sample customer-service policies
              and do not override information displayed by a future live
              checkout. Review the{" "}
              <Link
                className="content-page__inline-link"
                to="/shipping"
                onClick={scrollToTop}
              >
                shipping guide
              </Link>{" "}
              and{" "}
              <Link
                className="content-page__inline-link"
                to="/returns"
                onClick={scrollToTop}
              >
                returns guide
              </Link>
              . The way this storefront handles browser data is described in the{" "}
              <Link
                className="content-page__inline-link"
                to="/privacy"
                onClick={scrollToTop}
              >
                Privacy Policy
              </Link>
              .
            </p>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-brand"
          >
            <h2 id="terms-brand">6. Brand and site materials</h2>
            <p>
              “sickzuno” is the storefront brand. Site materials may not be copied
              or redistributed without permission. Product and editorial imagery
              used here is original or specifically created for this storefront.
            </p>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-disclaimer"
          >
            <h2 id="terms-disclaimer">7. Availability and responsibility</h2>
            <p>
              The storefront may contain temporary errors. To the extent
              allowed by applicable law, its maintainers do not promise
              uninterrupted availability or accept responsibility for decisions
              made as though it were a live shop.
            </p>
          </section>

          <section
            className="content-page__section"
            aria-labelledby="terms-changes"
          >
            <h2 id="terms-changes">8. Changes and questions</h2>
            <p>
              Features and this template may change as the project develops.
              Update the date above and obtain an appropriate review whenever
              the storefront’s real business practices change.
            </p>
          </section>

          <aside className="content-page__support" aria-label="Terms support">
            <div>
              <h2>Questions about this template?</h2>
              <p>Customer care can be reached at harv@sickzuno.online.</p>
            </div>
            <Link
              className="content-page__inline-link"
              to="/contact"
              onClick={scrollToTop}
            >
              Contact sickzuno
            </Link>
          </aside>
        </article>
      </div>
    </main>
  );
}

export default Terms;
